module.exports = __webpack_public_path__ + "static/media/Aalidhra7a2.6aad2c8f.jpg";